export default ({ user }) => user.permissions.can_ignore_user_groups;
